import { component } from 'picoapp'
import { debounce, loader } from '../lib/ults'

export default component((node, ctx) => {
    let search = {
        selector: {
            toggle: document.querySelectorAll('[data-search-toggle]'),
            input: node.querySelector('[data-search-input]'),
            close: node.querySelector('.search__close'),
            output: node.querySelector('[data-search-output]'),
            outputProducts: node.querySelector('[data-search-products]'),
            outputProductsList: node.querySelector('[data-search-products-list]'),
            outputPages: node.querySelector('[data-search-pages]'),
            outputArticles: node.querySelector('[data-search-articles]'),
            outputCollections: node.querySelector('[data-search-collections]'),
            productsTitle: node.querySelector('[data-products-title]'),
            collectionsTitle: node.querySelector('[data-collections-title]'),
            articlesTitle: node.querySelector('[data-articles-title]'),
            searchContainer: node.querySelector('[data-search-container]'),
            searchTermTag: node.querySelector('[data-search-term]'),
            outputProductsHeader: `<div class="search__heading">${theme.strings.search.products}</div>`,
            outputPagesHeader: `<div class="search__heading">${theme.strings.search.pages}</div>`,
            outputArticlesHeader: `<div class="search__heading">${theme.strings.search.articles}</div>`,
            outputCollectionsHeader: `<div class="search__heading">${theme.strings.search.collections}</div>`,
            noResult: `<div class="search__noresults">${theme.strings.search.noResults}</div>`,
            loadMore: node.querySelector('[data-load-more]'),
            searchForm: node.querySelector('[data-search-form]'),
            noResults: node.querySelectorAll('[data-no-result]')
        },
        emptyOutput: function () {
            this.selector.output.classList.add('visible')
            this.selector.outputProductsList.innerHTML = ""
            this.selector.outputArticles.innerHTML = ""
            this.selector.outputCollections.innerHTML = ""
            if (node.querySelector('.search__noresults')) node.querySelector('.search__noresults').remove()
        },
        toggle: function () {
            node.classList.toggle('hidden')
            document.body.classList.toggle('no-scroll')
        },
        submitSearch: function () {
            location.href = `/search?q=${this.selector.input.value}*`
        },
        on: function () {
            this.lastInputValue = this.selector.input.value
            if (this.selector.input.value === "") {
                this.emptyOutput()
                this.selector.output.classList.remove('visible')
                return
            }

            // ctx.emit("search:loading:start")

            fetch("/search?view=ajax&q=" + encodeURIComponent(this.lastInputValue) + "*&type=product,article,page")
                .then((r) => r.text())
                .then((contents) => {
                    const parser = new DOMParser()
                    const doc = parser.parseFromString(contents, 'text/html')

                    if (doc.querySelector('#results').hasChildNodes() === false) {
                        this.selector.output.insertAdjacentHTML('beforeend', this.selector.noResult)
                        this.selector.searchContainer.classList.add('hidden')
                        this.selector.searchTermTag.innerHTML = ''
                    } else {
                        this.selector.output.classList.add('visible')
                        this.selector.searchContainer.classList.remove('hidden')
                        this.selector.searchTermTag.innerHTML = this.selector.input.value
                    }

                    let products = doc.querySelectorAll('.type-product'),
                        articles = doc.querySelectorAll('.type-article'),
                        collections = doc.querySelectorAll('.type-collection')

                    if (products.length) {
                        // show title
                        this.selector.productsTitle.classList.remove('hidden')

                        // show container
                        this.selector.searchContainer.classList.remove('hidden')

                        // shuffle products to make the output random in efter search
                        const shuffled = Array.from(products).sort(() => 0.5 - Math.random())

                        // get sub-array of first 3 products after shuffled
                        let newProducts = shuffled.slice(0, 3)
                        
                        // output 3 random products based on search term
                        newProducts.forEach(prod => {
                            this.selector.outputProductsList.appendChild(prod)
                        })
                    } else {
                        this.selector.productsTitle.classList.add('hidden')
                    }

                    if (collections.length) {
                        // show title
                        this.selector.collectionsTitle.classList.remove('hidden')

                        // show container
                        this.selector.searchContainer.classList.remove('hidden')

                        // show container
                        this.selector.searchContainer.classList.remove('hidden')

                        // output max 6 collections
                        collections.forEach((collection, i) => {
                            if (i <= 6) this.selector.outputCollections.appendChild(collection)
                        })
                    } else {
                        this.selector.collectionsTitle.classList.add('hidden')
                    }

                    if (articles.length) {
                        // show title
                        this.selector.articlesTitle.classList.remove('hidden')

                        // show container
                        this.selector.searchContainer.classList.remove('hidden')

                        // output max 6 articles
                        articles.forEach((article, i) => {
                            if (i <= 6) this.selector.outputArticles.appendChild(article)
                        })
                    } else {
                        this.selector.articlesTitle.classList.add('hidden')
                    }

                    // ctx.emit("search:loading:end")
                })
        },
        init: function () {
            this.selector.input.addEventListener('keydown', debounce(function () {
                search.emptyOutput()
                search.on()
            }, 500))

            this.selector.toggle.forEach(item => {
                item.addEventListener('click', function () {
                    search.toggle()
                })
            })

            // Events
            ctx.on('search:loading:start', function () {
                loader(search.selector.output)
            })

            ctx.on('search:loading:end', function () {
                node.querySelector('.search__results .spinner').remove()
            })

            this.selector.loadMore.addEventListener('click', (e) => {
                e.preventDefault()
                this.submitSearch()
            })

            document.addEventListener('keyup', (e) => {
                if (e.keyCode === 13 && this.selector.input.value !== '') this.submitSearch()
            })
        }
    }

    search.init()
})